import { render, staticRenderFns } from "./solution-items.vue?vue&type=template&id=2029db86"
import script from "./solution-items.vue?vue&type=script&lang=js"
export * from "./solution-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports